<template>
    <div class="PatientChooseTime">
        <div v-if="showPage">
        <div class="container">
            <div class="appointment-list-2">
                <van-cell-group :border="false">
                    <template #title>
                    <span class="custom-title">基础信息</span>
                    </template>

                    <van-cell :border="false">   
                    <div style="color:#9D9D9D;white-space:nowrap;">患者姓名：</div>   <div>{{patient_name}}</div> 
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                             <div style="color:#9D9D9D;white-space:nowrap;">当前轮次、周期：</div>   <div>第{{rounds}}轮次 第{{rounds_phase}}周期</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">项目药房：</div>   <div>{{drugstore}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">药房地址：</div>   <div>{{drugstore_address}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">药房联系方式：</div>   <div>{{drugstore_phone}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">公益专员联系方式：</div>   
                            <div v-if="volunteer_name" style="word-break:normal;">{{volunteer_name}}/ {{volunteer_phone}}</div> 
                            <div v-else style="word-break:normal;">暂无</div>
                        </div>
                    </van-cell>
                </van-cell-group>
            </div>


            <van-cell-group  :border="false" inset class="contain-cell">

                <van-cell  :value="timeStr" class="timer" title="选择最近一次输注时间" required is-link  @click="openDatePicker()">
                    <template>
                        <div :style="{'color':timeStr=='请选择'?'#969799':'black'}">{{timeStr}}</div>
                    </template>
                </van-cell>

                <van-cell v-show="showNextTimeCell" class="" style="color:red;padding-top:0;" >
                    <template #title> <span>下一次的输注时间为{{nextTime}}</span> </template>
                </van-cell>

            </van-cell-group>
            <div style="font-size:12px;color:red;margin:5px;text-align:center;">请选择最近一次输注时间，推算出该患者的下一阶段输注时间</div>
        </div>
                <!-- 按钮组 -->
        <div class="btn">
            <van-button type="default" class="btn1" plain round @click="back()" color="#0AA8AF">
            返回</van-button>
            <van-button type="default" class="btn2" round @click="submit" color="#0AA8AF" :disabled="disabled" >
            提交并保存</van-button>
        </div>


        <!-- 弹出元素 -->
        <!-- 选择最近一次输注时间 -->
        <van-popup v-model="showDatePicker2" round position="bottom">
            <van-datetime-picker v-model="latestTreatmentDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="onLatestTreatmentDate" @cancel="showDatePicker2=false;"/>
        </van-popup>

        <van-popup v-model="showNextTime" round style="width:80vw;padding:20px;padding-bottom:10px;font-size:13px;border-radius:6px;">
          <div style="display:flex;justify-content:center;margin:10px 0 20px 0;">
            温馨提醒：按该患者最近一次用药时间，预计该患者的下次输注时间为：{{nextTime}}。请提醒该患者合理安排援助申请时间。
          </div>
          <div class="btn">
            <van-button class="btn1" size="" plain round @click="onCancel"  color="#0AA8AF">取消</van-button>
            <van-button class="btn1" size="" round @click="onNextTime"  color="#0AA8AF">确认</van-button>
          </div>
        </van-popup>
 </div>

<div v-else>
        <div class="container">
            <div class="appointment-list-2">
                <van-cell-group :border="false">
                    <template #title>
                    <span class="custom-title">基础信息</span>
                    </template>

                    <van-cell :border="false">   
                    <div style="color:#9D9D9D;white-space:nowrap;">患者姓名：</div>   <div>{{patient_name}}</div> 
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                             <div style="color:#9D9D9D;white-space:nowrap;">当前轮次、周期：</div>   <div>第{{rounds}}轮次 第{{rounds_phase}}周期</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">项目药房：</div>   <div>{{drugstore}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">药房地址：</div>   <div>{{drugstore_address}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">药房联系方式：</div>   <div>{{drugstore_phone}}</div> 
                        </div>
                    </van-cell>
                    <van-cell :border="false">   
                        <div class="alignment-flex">
                            <div style="color:#9D9D9D;white-space:nowrap;">公益专员联系方式：</div>   
                            <div v-if="volunteer_name" style="word-break:normal;">{{volunteer_name}}/ {{volunteer_phone}}</div> 
                            <div v-else style="word-break:normal;">暂无</div>
                        </div>
                    </van-cell>
                </van-cell-group>
            </div>

            <div class="checkin-btn">
                <van-button  round @click="showDialog" color="#0AA8AF">开启下一阶段</van-button>
            </div>
        </div>
    </div>

    </div>
</template>
<script>
import { newPhase } from '@/api/api'
import { Toast,Dialog } from 'vant'
import Vue from "vue";
import { mapState } from "vuex";
Vue.use(Toast)
Vue.use(Dialog)


export default {
    name:"chooseTime",
    data(){
        return {
            minDate: new Date(1949, 10, 1),
            // maxDate: new Date(2025,1,1),
            maxDate: new Date(),
            
            timeStr:"请选择",//最近治疗时间
            showDatePicker2:false,
            latestTreatmentDate:new Date(),
            showNextTime:false,
            showNextTimeCell:false,

            lastTime: '',

            disabled:false,

            patient_name:'',
            mode_type:'',
            rounds:'1',
            rounds_phase:'1',
            drugstore:'',
            drugstore_address:'',
            drugstore_phone:'',
            volunteer_phone:'',
            volunteer_name:'',

            phase_drug_field:{field_1:''},//阶段自定义字段:选择最近一次输注时间

            showPage:false,

            nextPhase:'',//下一阶段阶段数

        }
    },
    computed: {
        ...mapState(['patientOne', 'userInfo','patientInfo','publicWelfareStaff']),
        nextTime(){
            console.log(this.timeStr)
            let timeStr = this.timeStr.replace(/-/g,"/")
            console.log(timeStr)
            let temp=new Date(timeStr)
            let x=0;//年份
            let y=0;//月份
            let z=0;//日期
            temp.setFullYear(temp.getFullYear() + x);
            temp.setMonth(temp.getMonth() + y);//此处不加一
            temp.setDate(temp.getDate() + z + 21);//输注时间加21天
            return this.timeFormat(temp)//因为在timeFormat中会加一
        }
    },
    created(){
        this.papid=this.patientOne.papid;
        this.getData();
    },
    methods: {
        async getData(){
            // let res = await GetPatient({
            //     papid: this.papid
            // })
            let res={data: this.patientInfo}
            const {
                patient,
                drugstore,
                phase,
                predict,
                volunteer,
                mode_name,
                rounds_phase
            } = res.data;
            console.log(res.data)
            if(patient){
                this.patient_name=patient.name;
                this.rounds=patient.rounds;
                this.nextPhase=patient.receive_phase+1
            }
            this.mode_type=mode_name;
            this.rounds_phase=rounds_phase;
            if(drugstore){
                this.drugstore=drugstore.name;
                this.drugstore_address=drugstore.address;
                this.drugstore_phone=drugstore.druggist_phone;
            }
            if(volunteer){
                this.volunteer_phone=volunteer.mobile;
                this.volunteer_name=volunteer.name;
            }
        },
        onNextTime(){
            this.showNextTime=false
            this.showNextTimeCell=true
            this.lastTime=this.latestTreatmentDate//记录历史值
        },
        onCancel(){
            // this.showNextTimeCell=false;
            this.showNextTime=false;
            setTimeout(() => {
                if(this.lastTime==''){
                    this.timeStr='请选择'
                    this.phase_drug_field.field_1=''
                }else{
                    this.phase_drug_field.field_1=this.timeFormat(this.lastTime)
                    this.latestTreatmentDate=this.lastTime
                    this.timeStr=this.timeFormat(this.lastTime)
                }
            },300)
        },
        openDatePicker(){
            this.showDatePicker2=true;
        },
        onLatestTreatmentDate(value){
            this.latestTreatmentDate=value
            this.timeStr=this.timeFormat(value)
            this.phase_drug_field.field_1=this.timeFormat(value)
            this.showDatePicker2=false;
            this.showNextTime=true
        },
        showDialog(){
            console.log("nextPhase",this.nextPhase)
            Dialog.confirm({
                title: '',
                message: `您是否开启第${this.nextPhase}轮次申请`,
                confirmButtonColor:'#0AA8AF'
            })
            .then(() => {
                // on confirm
                this.showPage=true;
            })
            .catch(() => {
                // on cancel
            });
        },
        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day;
        },
        back(){
            this.$router.go(-1)
            // this.$router.push({name:"Timeline"})
        },
        async submit(){
            if(!this.phase_drug_field.field_1){
                Toast("请选择最近一次输注时间")
                return
            }
            // console.log(this.phase_drug_field.field_1)
            // return
            await newPhase({
                papid: this.papid,
                phase_drug_field:this.phase_drug_field,
                current_volunteer_id:this.publicWelfareStaff.checkin_info.papid
            }).then(res => {
                this.$router.go(-1)
                this.submitisabled = false
                Toast.clear()
            }).catch(err => {
                this.submitisabled = false
                // Toast.clear()
                Toast(err.response.data.message)
            })

        }
    },
    
}

</script>
<style lang="less" scoped>
.PatientChooseTime{
    .container{
        min-height: 85vh;
    
        .appointment-list-2 .van-cell-group__title{
            background: #0aa8af;
            color:white;
        }
        .van-cell-group__title {
            color: #fff;
            padding: 10px;
            .custom-title{
            margin-left: 10px;
            }
            &::after {
            content: "";
            width: 4px;
            height: 15px;
            background-color: #e8f4a6;
            position: absolute;
            left: 25px;
            border-radius: 2px;
            }
        }
        .appointment-list-2{
            box-sizing: border-box;
            margin: 16px;
            border-radius: 10px;
            box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
            // box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
            border: 1px solid rgba(255, 255, 255, 0);
            overflow: hidden;
            .van-cell__value{
            display:flex;
            justify-content:flex-start;
            align-items:center;
                .alignment-flex{
                    display:flex;
                    justify-content:flex-start;
                    align-items:flex-start;
                }
            }
            .appointment-status {
            box-sizing: border-box;
            //   padding: 10px 15px;
            //   margin: 16px;
            border-radius: 10px;
            overflow: hidden;
            //   background-color: #FFDADB;
            font-size: 14px;
            color:#FF4830;
            .img-status{
                display: flex;
                align-items: center;
            }
            &.red {
                color: @red;
            }
            }
        }
        .contain-cell{
            // box-shadow: 0 0 8px  rgba(0, 0, 0, 0.15);
            box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
            border-radius: 8px;
            display: flex;
            flex-flow: column nowrap;
            justify-content:center;
            align-items:center;
            margin: 20px 16px 10px 16px;
            .van-cell{
                border-radius: 8px;
            }
            .timer{
                &::after{
                    border-bottom:none !important;
                }
                .van-cell__value{
                    flex:1 0;
                }
                .van-cell__title{
                    flex:2 0;
                }
            }
        }

    }

    .checkin-btn {
      margin: 35px 16px;
      display: flex;
      justify-content:center;
      button{
          width:75vw;
      }
    }


    .btn{
      display: flex;
      justify-content:space-between;
      width: 100%;
      padding: 10px;
      // background-color: white;
      margin: 0;
      .van-button{
        margin: 0 5px;
        white-space: nowrap;
      }
      .btn1{flex-grow: 1;}
      .btn2{flex-grow: 4;}
    }
}
</style>